import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Founder from "./sections/Founder";
import Mission from "./sections/Mission";
import Legacy from "./sections/Legacy";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Founder />
      <Mission />
      <Legacy />
      <Footer />
    </div>;
}